import React from "react";
import html from "../assets/html-logo.png";
import css from "../assets/css3-logo.png";
import javascript from "../assets/javascript-logo.png";
import react from "../assets/react-logo.png";
import tailwind from "../assets/Tailwind CSS-logo.png";
import cpp from "../assets/c-logo.png";
import github from "../assets/GitHub-logo.png";
import express from "../assets/express.png";
import socketio from "../assets/socketio.png";
import nodejs from "../assets/nodejs.png";
import mongodb from "../assets/mongodb.svg";
import mysql from "../assets/mysql.png";
function Experience() {
  const techs = [
    {
      id: 1,
      src: html,
      title: "HTML",
      style: "shadow-orange-500",
    },
    {
      id: 2,
      src: css,
      title: "CSS",
      style: "shadow-blue-500",
    },
    {
      id: 3,
      src: javascript,
      title: "JavaScript",
      style: "shadow-yellow-500",
    },
    {
      id: 4,
      src: react,
      title: "React",
      style: "shadow-sky-400",
    },
    {
      id: 5,
      src: tailwind,
      title: "Tailwind",
      style: "shadow-sky-400",
    },
    {
      id: 6,
      src: cpp,
      title: "C++",
      style: "shadow-sky-500",
    },
    {
      id: 7,
      src: github,
      title: "GitHub",
      style: "shadow-gray-200",
    },
    {
      id: 8,
      src: express,
      title: "Express.js",
      style: "shadow-gray-200",
    },
    {
      id: 9,
      src: socketio,
      title: "Socket.io",
      style: "shadow-gray-200",
    },
    {
      id: 10,
      src: nodejs,
      title: "Node.js",
      style: "shadow-green-400",
    },
    {
      id: 11,
      src: mongodb,
      title: "MongoDB",
      style: "shadow-green-800",
    },
    {
      id: 12,
      src: mysql,
      title: "MySQL",
      style: "shadow-blue-800",
    },
  ];
  return (
    <div
      name="experience"
      className="bg-gradient-to-b from-gray-800 via-black to-gray-800 w-full min-h-screen pt-20"
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
        <div>
          <p className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline ">
            Experience
          </p>
          <p className="py-6">These are the Technologies I've worked with...</p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0">
          {techs.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-300 py-2 rounded-lg' ${style}`}
            >
              <img src={src} alt="" className="w-20 mx-auto" />
              <p className="mt-4">{title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Experience;
